import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Container } from "react-bootstrap";
import Swal from "sweetalert2";

const Users = () => {
  const [users, setUsers] = useState([]);
  const apiUrl = process.env.REACT_APP_API_URL;

  const fetchUsers = () => {
    axios
      .get(`${apiUrl}/get-users`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        setUsers(response.data);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        Swal.fire("Error", "Failed to fetch users", "error");
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [apiUrl]);

  const toggleStatus = (id) => {
    axios
      .patch(`${apiUrl}/user-status/${id}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        Swal.fire("Success", response.data.message, "success");
        fetchUsers(); // Refresh the list
      })
      .catch((error) => {
        console.error("Toggle error:", error);
        Swal.fire("Error", "Failed to toggle status", "error");
      });
  };

  return (
    <Container className="mt-4">
      <h3 className="mb-4">User List</h3>
      <Table
        bordered
        hover
        responsive
        className="text-center"
        style={{ backgroundColor: "aliceblue" }}
      >
        <thead className="table-primary">
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Address</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? (
            users.map((user, index) => (
              <tr key={user.id}>
                <td>{index + 1}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>{user.contact}</td>
                <td>{user.address}</td>
                <td>
                  <button
                    onClick={() => toggleStatus(user.id)}
                    className={`fw-bold btn btn-sm ${
                      user.isActive ? "btn-success" : "btn-danger"
                    }`}
                    style={{ width: "100px" }}
                  >
                    {user.isActive ? "✅ Active" : "❌ Inactive"}
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

export default Users;
